/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';
import Label from './Label';
import DotButton from '../buttons/Dot';
import styles from '../../../styles/partials/carousel.scss';

// import yellowCarousel from '../../../img/carousel-background-yellow.png';

const propTypes = {
    title: PropTypes.node.isRequired,
    items: PropTypes.array.isRequired, // eslint-disable-line
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Carousel = ({ title, items, className }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [automaticSlide, setAutomaticSlide] = useState(true);
    const [timeoutId, setTimeoutId] = useState(true);

    const onDotClick = index => {
        setAutomaticSlide(false);
        return setCurrentIndex(index);
    };

    const nextSlide = () => {
        if (currentIndex === items.length - 1) {
            return setCurrentIndex(0);
        }
        return setCurrentIndex(currentIndex + 1);
    };

    useEffect(() => {
        let id;
        if (automaticSlide && items.length > 1) {
            id = setTimeout(() => nextSlide(), 10000);
            setTimeoutId(id);
        }
        return () => {
            clearTimeout(id);
        };
    }, [currentIndex, items]);

    useEffect(() => {
        if (automaticSlide === false) {
            clearTimeout(timeoutId);
        }
    }, [automaticSlide, timeoutId]);

    const dotColor = index => {
        if (index === currentIndex) {
            return '#0d7d6d';
        }
        return '#df451f';
    };

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            // style={{
            //     backgroundImage: `url(${yellowCarousel})`,
            // }}
        >
            <div className={styles.bar}>
                <div className={styles.title}>
                    <Label>{title}</Label>
                </div>
                <div className={styles.slides}>
                    {items.map((slide, index) => (
                        <div
                            className={classNames([
                                styles.slide,
                                {
                                    [styles.before]: index < currentIndex,
                                    [styles.current]: index === currentIndex,
                                    [styles.after]: index > currentIndex,
                                },
                            ])}
                        >
                            <div className={styles.quote}>
                                <span className={styles.marks}>&quot;</span>
                                {/* eslint-disable-line*/}
                                <Label>{slide.quote}</Label>
                                <span className={styles.marks}>&quot;</span>
                                {/* eslint-disable-line*/}
                            </div>
                            <div className={styles.description}>
                                <Label>{slide.description}</Label>
                            </div>
                        </div>
                    ))}
                </div>
                <div className={styles.navigation}>
                    {items.length > 1
                        ? items.map((slide, index) => (
                            <DotButton
                                className={styles.dot}
                                onClick={() => onDotClick(index)}
                                color={dotColor(index)}
                              />
                          ))
                        : null}
                </div>
            </div>
        </div>
    );
};

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;

export default Carousel;
